import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import RangeSliderComponent from '../../../core/components/rangeSlider/RangeSliderComponent';
import { textSettingsChangeIndentRight } from '../state/controller';
import { AppStateTypes } from '../../../store/appStateTypes';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';

const IndentRightContainer = () => {
  const dispatch = useDispatch();

  const { indentRight } = useSelector((state: AppStateTypes) => state.textSettings);

  const onChangeIndentRight = (value: string) => {
    dispatch(textSettingsChangeIndentRight(+value));
  };

  return (
        <PanelSubSectionComponent>
            <p>Отступ справа: {indentRight}px</p>
            <RangeSliderComponent defaultValue={indentRight} min={0} max={400} onChange={onChangeIndentRight} />
        </PanelSubSectionComponent>
  );
};

export default IndentRightContainer;
